/**
 * Kuspit requires the real place an instruction is given (contract opening, transactional profile,
 * transfers), so the browser is asked for it. Rounded to six decimals, as Kuspit's examples are.
 */
export function currentPosition(): Promise<{ latitude: number; longitude: number }> {
  return new Promise((resolve, reject) => {
    if (!("geolocation" in navigator)) { reject(new Error("Este navegador no comparte ubicación.")); return; }
    navigator.geolocation.getCurrentPosition(
      (position) => resolve({ latitude: Number(position.coords.latitude.toFixed(6)), longitude: Number(position.coords.longitude.toFixed(6)) }),
      () => reject(new Error("Kuspit pide la ubicación real desde donde haces este trámite. Permite el acceso a tu ubicación e inténtalo de nuevo.")),
      { enableHighAccuracy: true, timeout: 15_000, maximumAge: 60_000 }
    );
  });
}
